<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de Viagem por veículo">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/relatorio-viagem-veiculo/List'

export default {
    components: { List },
}
</script>
